module.exports = __webpack_public_path__ + "static/media/circled-info.1ed9b905.svg";